// extracted by mini-css-extract-plugin
export default {"section":"Education_section__yE46B"};